module.exports = __webpack_public_path__ + "img/4399.2fd522d2.png";